// extracted by mini-css-extract-plugin
export var divider = "_15-0";
export var dividerText = "_15-1";